import styles from "./Face2.module.scss";

export default function Face2() {
  return <div className={styles.card}></div>;
}
